import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b3a30cd8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "searchTabs layout font-28" };
const _hoisted_2 = {
    key: 0,
    class: "vipListWrapper"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 2,
    class: "comingWrapper border-box p-b20"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { key: 1 };
import { nextTick, ref, watch, onMounted, computed } from 'vue';
import BetterScroll from '@/components/common/BetterScroll.vue';
import { getDomWidth } from '@/widget/index';
import { useVipList, useSubDep, useCourseType, loading, getCourse, comingList, activeComing, selectComing, setVip188, initFn } from './search';
export default /*#__PURE__*/ _defineComponent({
    props: {
        courseType: {
            default: '',
            type: String
        },
        select: {
            default: false,
            type: Boolean
        },
        vip188: {
            default: false,
            type: Boolean
        }
    },
    setup(__props) {
        const props = __props;
        const options = {
            scrollY: false,
            scrollX: true,
            click: false,
            mouseWheel: false,
            scrollbar: {
                fade: false,
                interactive: true
            }
        };
        setVip188(props.vip188);
        initFn();
        // 计算要滚动的距离
        const countLeft = (className) => {
            if (!className) {
                return 0;
            }
            let parent = document.querySelector('.' + className);
            let child = document.querySelector('.' + className + ' .active');
            if (!parent || !child) {
                return 0;
            }
            // 父元素宽度
            let pw = parent?.offsetWidth;
            let cw = child?.offsetWidth;
            let cw2 = parseInt(cw / 2 + '', 10);
            let cl = child?.offsetLeft;
            let cr = pw - cw - cl; // 元素距离右侧距离
            let ww = window.innerWidth;
            let ww2 = parseInt(ww / 2 + '', 10);
            if (ww2 > cw2 + cl || pw < ww) {
                return 0;
            }
            else if (cr < ww2) {
                return ww - pw;
            }
            else {
                return ww2 - (cl + cw2);
            }
        };
        const vipDom = ref();
        const vipW = ref(7.5);
        const vipBs = ref();
        let { vipList, selectVip, activeVip } = useVipList();
        watch(() => activeVip.value, () => {
            nextTick(() => {
                vipW.value = getDomWidth(vipDom.value, 40, 32);
                vipBs.value?.refreshBs();
                let l = countLeft('vipList');
                vipBs.value?.scrollTo(l, 0);
            });
        });
        // 亚专业
        let { selectSubDep, activeSubDep, subDepList, activeMeta, selectMeta } = useSubDep();
        const metaW = ref(7.5); // 知识元列表宽度
        const depW = ref(7.5);
        const depDom = ref();
        const depMetaBs = ref();
        const subDepBs = ref();
        const metaDom = ref();
        watch(() => activeSubDep.value, (item) => {
            nextTick(() => {
                subDepBs.value?.scrollTo(countLeft('subDepList'), 0);
            });
            if (item && props.select) {
                metaW.value = 7.5;
                activeMeta.value = item.knowledgeElementList[0];
                if (item.knowledgeElementList.length) {
                    setMetaW();
                }
            }
        });
        watch(() => activeMeta.value, () => {
            nextTick(() => {
                depMetaBs.value?.scrollTo(countLeft('depMetaList'), 0);
            });
        });
        // 课程类型
        let { selectType, activeType, typeList, activeSubType, selectSubType } = useCourseType();
        const typeW = ref(7.5);
        const subTypeW = ref(7.5);
        const typeDom = ref();
        const subTypeDom = ref();
        const subTypeBs = ref();
        const typeBs = ref();
        watch(() => activeType.value, (item) => {
            if (item && props.select) {
                activeSubType.value = item.detailTypeList[0];
                setSubTypeW();
            }
        });
        watch(() => activeSubType.value, () => {
            nextTick(() => {
                subTypeBs.value?.scrollTo(countLeft('subTypeList'), 0);
            });
        });
        const loaded = ref(false);
        watch(() => loading.value, n => {
            if (!n) {
                nextTick(() => {
                    setWidth();
                    getCourse();
                });
            }
        });
        let initFlag = true;
        // 设置宽度
        const setWidth = () => {
            nextTick(() => {
                vipW.value = getDomWidth(vipDom.value, 40, 32);
                typeW.value = getDomWidth(typeDom.value, 36, 16);
                typeBs.value?.refreshBs();
            });
            depW.value = getDomWidth(depDom.value, 36, 16);
            // 子选项选中
            subTypeW.value = getDomWidth(subTypeDom.value, 36, 16);
            metaW.value = getDomWidth(metaDom.value, 36, 16);
            loaded.value = true;
            // 设置滚动位子
            if (initFlag) {
                nextTick(() => {
                    vipBs.value?.scrollTo(countLeft('vipList'), 0);
                    // typeBs.value?.scrollTo(countLeft('typeList'), 0)
                    // subTypeBs.value?.scrollTo(countLeft('subTypeList'), 0)
                    // subDepBs.value?.scrollTo(countLeft('subDepList'), 0)
                    // depMetaBs.value?.scrollTo(countLeft('depMetaList'), 0)
                    initFlag = false;
                });
            }
        };
        // 设置课程子类宽度
        const setSubTypeW = () => {
            subTypeW.value = 7.5;
            vipW.value = 7.5;
            nextTick(() => {
                subTypeW.value = getDomWidth(subTypeDom.value, 36, 16);
                vipW.value = getDomWidth(vipDom.value, 40, 32);
                if (subTypeBs.value) {
                    subTypeBs.value?.refreshBs();
                    subTypeBs.value && subTypeBs.value.scrollTo(0, 0);
                }
            });
        };
        // 设置知识元宽度
        const setMetaW = () => {
            metaW.value = 7.5;
            nextTick(() => {
                metaW.value = getDomWidth(metaDom.value, 36, 16);
                if (depMetaBs.value) {
                    depMetaBs.value?.refreshBs();
                    depMetaBs.value?.scrollTo(0, 0);
                }
            });
        };
        onMounted(() => {
            if (loading.value == false) {
                // 判断是否有缓存
                setWidth();
            }
        });
        // 筛选展示判断
        const showVip = computed(() => {
            if (!activeType.value?.id) {
                return true;
            }
            else if (!/^(omo|open)$/.test(String(activeType.value?.id))) {
                return true;
            }
            else if (isVip188()) {
                vipW.value = getDomWidth(vipDom.value, 40, 32);
                return true;
            }
            return false;
        });
        const showType = computed(() => {
            if (!activeVip.value?.id) {
                return true;
            }
            else if (isVip188()) {
                return true;
            }
            return false;
        });
        //是否是188
        const isVip188 = () => {
            return props.vip188;
        };
        //是否显示课程类型选择
        const showCourseTypeDiv = () => {
            if (props.vip188) {
                nextTick(() => {
                    typeW.value = getDomWidth(typeDom.value, 36, 16);
                    subTypeW.value = getDomWidth(subTypeDom.value, 36, 16);
                    if (typeBs.value) {
                        typeBs.value?.refreshBs();
                        typeBs.value?.scrollTo(countLeft('typeList'), 0);
                    }
                    if (subTypeBs.value) {
                        subTypeBs.value?.refreshBs();
                        subTypeBs.value?.scrollTo(countLeft('subTypeList'), 0);
                    }
                });
                return activeVip.value?.id == 1;
            }
            else {
                return !/^(omo|open)$/.test(props.courseType);
            }
        };
        //是否显示亚专业选择
        const showSubTypeDiv = () => {
            if (props.vip188) {
                nextTick(() => {
                    depW.value = getDomWidth(depDom.value, 36, 16);
                    metaW.value = getDomWidth(metaDom.value, 36, 16);
                    if (subDepBs.value) {
                        subDepBs.value?.refreshBs();
                        subDepBs.value?.scrollTo(countLeft('subDepList'), 0);
                    }
                    if (depMetaBs.value) {
                        depMetaBs.value?.refreshBs();
                        depMetaBs.value?.scrollTo(countLeft('depMetaList'), 0);
                    }
                });
                return activeVip.value?.id == 1;
            }
            else {
                return true;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!/^(omo|open|master_class)$/.test(__props.courseType))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(BetterScroll, {
                            ref: (_value, _refs) => {
                                _refs['vipBs'] = _value;
                                vipBs.value = _value;
                            },
                            options: options,
                            loaded: loaded.value,
                            domStyle: {
                                position: 'relative',
                                height: '0.9rem'
                            },
                            wrapperStyle: {
                                width: vipW.value + 'rem'
                            }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("ul", {
                                    class: "vipList border-box p-lr16 gray-6 font-32",
                                    ref: (_value, _refs) => {
                                        _refs['vipDom'] = _value;
                                        vipDom.value = _value;
                                    }
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vipList), (vip, key) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("li", {
                                            class: _normalizeClass(["p-lr16 float-l", { active: _unref(activeVip)?.id === vip.id }]),
                                            key: key,
                                            onClick: _withModifiers(($event) => (_unref(selectVip)(vip, setWidth)), ["stop"])
                                        }, _toDisplayString(vip.name), 11, _hoisted_3)), [
                                            [_vShow, _unref(showVip) || !vip.id]
                                        ]);
                                    }), 128))
                                ], 512)
                            ]),
                            _: 1
                        }, 8, ["loaded", "domStyle", "wrapperStyle"])
                    ]))
                    : _createCommentVNode("", true),
                (showCourseTypeDiv())
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["courseTypeWrapper border-box", {
                                'p-b20': !_unref(activeType)?.detailTypeList.length || __props.courseType == 'master_class'
                            }])
                    }, [
                        _createVNode(BetterScroll, {
                            ref: (_value, _refs) => {
                                _refs['typeBs'] = _value;
                                typeBs.value = _value;
                            },
                            options: options,
                            loaded: loaded.value,
                            domStyle: {
                                position: 'relative',
                                height: '0.8rem'
                            },
                            wrapperStyle: {
                                width: typeW.value + 'rem'
                            }
                        }, {
                            default: _withCtx(() => [
                                (__props.courseType != 'master_class')
                                    ? (_openBlock(), _createElementBlock("ul", {
                                        key: 0,
                                        class: "typeList p-t20 border-box p-lr16 clearfix",
                                        ref: (_value, _refs) => {
                                            _refs['typeDom'] = _value;
                                            typeDom.value = _value;
                                        }
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item, key) => {
                                            return _withDirectives((_openBlock(), _createElementBlock("li", {
                                                key: key,
                                                class: _normalizeClass(["p-lr16 float-l", {
                                                        active: _unref(activeType)?.id == item.id,
                                                        radius: _unref(activeType)?.detailTypeList.length
                                                    }]),
                                                onClick: _withModifiers(($event) => (_unref(selectType)(item, setSubTypeW)), ["stop"])
                                            }, _toDisplayString(item.name), 11, _hoisted_4)), [
                                                [_vShow, _unref(showType) || !item.id || item.id == 'master_class']
                                            ]);
                                        }), 128))
                                    ], 512))
                                    : (_openBlock(), _createElementBlock("ul", {
                                        key: 1,
                                        class: "typeList p-t20 border-box p-lr16 clearfix",
                                        ref: (_value, _refs) => {
                                            _refs['typeDom'] = _value;
                                            typeDom.value = _value;
                                        }
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeType)?.detailTypeList, (item) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                class: _normalizeClass(["p-lr16 float-l", { active: _unref(activeSubType)?.id == item.id }]),
                                                key: item.id,
                                                onClick: _withModifiers(($event) => (_unref(selectSubType)(item)), ["stop"])
                                            }, _toDisplayString(item.name), 11, _hoisted_5));
                                        }), 128))
                                    ], 512))
                            ]),
                            _: 1
                        }, 8, ["loaded", "domStyle", "wrapperStyle"]),
                        (__props.courseType != 'master_class')
                            ? _withDirectives((_openBlock(), _createBlock(BetterScroll, {
                                key: 0,
                                ref: (_value, _refs) => {
                                    _refs['subTypeBs'] = _value;
                                    subTypeBs.value = _value;
                                },
                                options: options,
                                loaded: loaded.value,
                                domStyle: {
                                    position: 'relative',
                                    height: '0.76rem'
                                },
                                class: "gray-bg-e",
                                wrapperStyle: {
                                    width: subTypeW.value + 'rem'
                                }
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("ul", {
                                        class: "subTypeList border-box p-lr16 clearfix",
                                        ref: (_value, _refs) => {
                                            _refs['subTypeDom'] = _value;
                                            subTypeDom.value = _value;
                                        }
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeType)?.detailTypeList, (item) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                class: _normalizeClass(["gray-6 p-lr16 float-l", { active: _unref(activeSubType)?.id == item.id }]),
                                                key: item.id,
                                                onClick: _withModifiers(($event) => (_unref(selectSubType)(item)), ["stop"])
                                            }, _toDisplayString(item.name), 11, _hoisted_6));
                                        }), 128))
                                    ], 512)
                                ]),
                                _: 1
                            }, 8, ["loaded", "domStyle", "wrapperStyle"])), [
                                [_vShow, _unref(activeType)?.detailTypeList.length]
                            ])
                            : _createCommentVNode("", true)
                    ], 2))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["subDepWrapper border-box", { 'p-b20': !_unref(activeSubDep)?.knowledgeElementList.length }])
                }, [
                    _createVNode(BetterScroll, {
                        ref: (_value, _refs) => {
                            _refs['subDepBs'] = _value;
                            subDepBs.value = _value;
                        },
                        options: options,
                        loaded: loaded.value,
                        domStyle: {
                            position: 'relative',
                            height: '0.8rem'
                        },
                        wrapperStyle: {
                            width: depW.value + 'rem'
                        }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("ul", {
                                class: "subDepList p-t20 border-box p-lr16 clearfix",
                                ref: (_value, _refs) => {
                                    _refs['depDom'] = _value;
                                    depDom.value = _value;
                                }
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subDepList), (item) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: _normalizeClass(["float-l p-lr16", {
                                                active: _unref(activeSubDep)?.id == item.id,
                                                radius: _unref(activeSubDep)?.knowledgeElementList.length
                                            }]),
                                        onClick: _withModifiers(($event) => (_unref(selectSubDep)(item, setMetaW)), ["stop"]),
                                        key: item.id
                                    }, _toDisplayString(item.name), 11, _hoisted_7));
                                }), 128))
                            ], 512)
                        ]),
                        _: 1
                    }, 8, ["loaded", "domStyle", "wrapperStyle"]),
                    _withDirectives(_createVNode(BetterScroll, {
                        ref: (_value, _refs) => {
                            _refs['depMetaBs'] = _value;
                            depMetaBs.value = _value;
                        },
                        options: options,
                        class: "gray-bg-e",
                        loaded: loaded.value,
                        domStyle: {
                            position: 'relative',
                            height: '0.8rem'
                        },
                        wrapperStyle: {
                            width: metaW.value + 'rem'
                        }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("ul", {
                                class: "depMetaList border-box p-lr16 clearfix",
                                ref: (_value, _refs) => {
                                    _refs['metaDom'] = _value;
                                    metaDom.value = _value;
                                }
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeSubDep)?.knowledgeElementList, (item) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: _normalizeClass(["gray-6 p-lr16 float-l", { active: _unref(activeMeta)?.id == item.id }]),
                                        onClick: _withModifiers(($event) => (_unref(selectMeta)(item)), ["stop"]),
                                        key: item.id
                                    }, _toDisplayString(item.name), 11, _hoisted_8));
                                }), 128))
                            ], 512)
                        ]),
                        _: 1
                    }, 8, ["loaded", "domStyle", "wrapperStyle"]), [
                        [_vShow, _unref(activeSubDep)?.knowledgeElementList.length]
                    ])
                ], 2), [
                    [_vShow, showSubTypeDiv()]
                ]),
                (/^omo$/.test(__props.courseType) ||
                    (__props.courseType == 'master_class' && _unref(activeSubType)?.id == 'online'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("ul", {
                            class: "comingList p-t20 border-box p-lr16 clearfix",
                            ref: (_value, _refs) => {
                                _refs['comingDom'] = _value;
                            }
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comingList), (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    class: _normalizeClass(["float-l p-lr16", {
                                            active: _unref(activeComing)?.id === item.id
                                        }]),
                                    onClick: _withModifiers(($event) => (_unref(selectComing)(item)), ["stop"]),
                                    key: item.id
                                }, [
                                    (_unref(activeSubType)?.id == 'omo' || __props.courseType == 'omo')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.id !== 0 ? item.name : '往期召开'), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.id !== 0 ? item.name : '随到随学'), 1))
                                ], 10, _hoisted_10));
                            }), 128))
                        ], 512)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
